import React, { Component } from "react";
import { connect } from "react-redux";
import constants from "../../globalization";
import { TimeConstants } from "../../constants";
import {
  LogLevelEnum,
  SourceTypes,
  NotificationType,
} from "../../enums";
import {
  updateStatusType,
  updateNotificationType,
  updateNotification,
  updateCheckSort,
} from "../../store/actions/notification";
import { acknowledgeNoticationAction } from "../../store/actions/notifications";
import { getPopupConfig } from "../../components/Popup";
import FireboardUtils from "../../util/fireboard-util";
import MenuUTIL from '../../util/menu-utils';
import DBManager from "../../services/db-manager";
import API from "../../requests";
import FBCommonUtil from '../Fireboard/common';
import { tableReceipt } from "../../store/actions/tables";
import data from "./components/Header/constants";
import { login as loginAction } from '../../store/actions/login';

import View from "./views";
import UTIL from "mroads-js-utils";
import UTILLib from "../../util";
import { filterInfo } from "./data";
import EventEmitter from '../../util/event-emitter';
import { version } from '../../../package.json';
import { getPickerData } from "../../components/CountryPicker";
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import { updateComponentState } from '../../store/actions/component-state';
import { addPrintLog } from "../../store/actions";
import moment from 'moment';

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

const STATUS_TYPE = "status-type";
const ORDER_TYPE = "order-type";
const NOTIFICATION = "notification";

const allOrderType = {
  externalId: "0",
  id: 0,
  name: "All",
  shortName: null,
};

const POPUPS_ENUMS = {
  SMS: "sms",
  GENERATE_QR: "generate-qr",
  GENERATE_QR_PAY: "generate-qr-pay",
  MEMBER_DETAILS: "member-details",
  GENERATE_QR_JOIN_CHECK: "generate-qr-join-check",
};

class Fireboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredChecklist: [],
      isFetching: false,
      popup: undefined,
      isDevEnvironment: false,
      orderType: "",
      orderStatusType: constants.orderInProgress,
      value: "",
      notificationControlEnabled: false,
      countStatus: {
        curbside: true,
        online: true,
        walkup: true,
      },
      snoozeEnabled: false,
      selectedItem: {},
      items: [],
      showNotifications: false,
      fromFooter: false,
      preAuthItem: {},
      managerMode: false,
      pendingCheckItems: [],
      notificationType: [],
      activeMgrFilter: 'all',
      counters: [],
      selectedReason: {},
      sensorData: {},
      sortFilter: false,
      outOfStockMode: '',
      outOfStockItems: [],
      outOfStockSearchList: [],
      isClickedOutOfStock: false,
      loginInfo: null,
      isMultiPrint: false,
      multipleStores: [],
      printLogs: [],
    };

    this.checks = new Map();
    this.checkSubscriber = null;
    this.allowSyncData = false;
    this.filteredCheckItems = [];
    this.notificationTimeout = null;
    this.notificationTimestamp = new Date().getTime();
    this.snoozeTimeInterval = null;
    this.notificationSubscriber = null;
    this.requestClicked = false;
    this.onIntialize = null;
    this.futureCheckItems = [];
    this.allowPairWatch = false;
    this.notificationSubscriberMap = new Map();
    this.checkSubscriberMap = new Map();
    this.notificationsMap = new Map();
  }

  currency = this.props?.reduxProps?.currencyInfo?.currency || '$';
  countriesData;

  componentDidMount() {
    const {
      history,
      reduxProps: { storeTypesPersist, storeInfo, deviceInfo, checkSortReducer, deviceApiData, deviceApi },
    } = this.props;

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting PrintSever component with storeId ${storeInfo?.data?.id} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }
    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 13 }
      });
      return;
    }

    this.countriesData = getPickerData();
    const countryCode = this.currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    this.setState({
      selectedCountry: this.countriesData.find(country => country.iso2 === countryCode),
    });

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      this.setState({ isDevEnvironment: true });
    }
    this.state.notificationType = storeTypesPersist.data.notificationTypes || [];

    if (storeTypesPersist.data.activeCheckFilter === "sourceType") {
      this.setOrderType(storeTypesPersist.data.sourceTypes);
    } else if (storeTypesPersist.data.activeCheckFilter === "orderType") {
      this.setOrderType(storeTypesPersist.data.orderTypes);
    } else {
      this.setOrderType(storeTypesPersist.data.revenueTypes);
    }

    if (storeTypesPersist.data.notificationTypes) {
      this.setNotificationType(storeTypesPersist.data.notificationTypes);
    }

    const { guestAppFeatures, productionRate, prepWindow } = storeInfo.data || {};
    const { supportsCurbsideOrdering, supportsOnlineOrdering, supportsWalkUpOrdering } = guestAppFeatures || {};
    this.state.countStatus = {
      curbside: supportsCurbsideOrdering,
      online: supportsOnlineOrdering,
      walkup: supportsWalkUpOrdering,
    };
    this.state.productionTime = productionRate;
    this.state.prepTime = prepWindow;
    this.state.counters = storeTypesPersist.data.counterTypes || [];
    this.state.sortFilter = checkSortReducer && checkSortReducer.data ? checkSortReducer.data.sortFilter : false;

    if (window.ReactNativeWebView) EventEmitter.sendAppMode(version);

    if ((deviceApiData && deviceApiData.venueMode) || (deviceApi && deviceApi.data && deviceApi.data.venueMode)) {
      this.setState({ isMultiPrint: true });
      this.getVenueInfo(deviceApi?.data?.deviceId);
    }

    const { context } = this.props;
    this.setChecks(context?.checks);
    const { dispatchUpdateCompState } = this.props;
    dispatchUpdateCompState && dispatchUpdateCompState({ mounted: true });
  }

  componentWillUnmount() {
    const { dispatchUpdateCompState } = this.props;
    dispatchUpdateCompState && dispatchUpdateCompState({ mounted: false });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { reduxProps, location } = newProps;
    const { reduxProps: prevReduxProps } = this.props;
    const { tableReceiptPrint, printLogs } = reduxProps;
    const { managerMode } = this.state;

    this.handleLoginAction(reduxProps);
    if (
      location &&
      location.state &&
      location.state.managerMode &&
      location.state.managerMode !== managerMode
    ) {
      const { managerMode: updatedMode } = location.state;
      this.setState({ managerMode: updatedMode, selectedItem: {}, items: [] });
    }
    if (prevReduxProps.tableReceiptPrint.timestamp !== tableReceiptPrint.timestamp) {
      if (tableReceiptPrint.isFetching) {
        this.getSpinner('spinner', constants.printLoading, null);
      } else if (tableReceiptPrint.error) {
        this.getSpinner('error', null, tableReceiptPrint.error);
      } else if (tableReceiptPrint.data) {
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = `${constants.printWithStation} ${tableReceiptPrint.data.printerName}`;
        this.setState({ popup: printPopup });
        var data = {
          type: "print",
          data: tableReceiptPrint.data,
        };
        const errorMsg = "Trying to connect to " + tableReceiptPrint.data.printerName + " with IP Address " + tableReceiptPrint.data.printerIpAddress + " and port " + tableReceiptPrint.data.printerPort + " ";
        UTILLib.printReceipt(
          data,
          () => this.dismissPopup(),
          error => this.getSpinner('error', null, errorMsg + error),
          () => {
            let popup = getPopupConfig('error', () => this.dismissPopup());
            popup.message = constants.extensionNotAvailable;
            this.setState({ popup });
          },
        );
        setTimeout(() => {
          this.dismissPopup();
        }, 4000);
      }
    }

    if (this.props?.context !== newProps?.context) {
      const { context: nextContext } = newProps;
      this.setChecks(nextContext?.checks, nextContext?.deletedChecks);
      if (nextContext?.newNotifications && nextContext.newNotifications.length) {
        this.handleNewNotification(nextContext.newNotifications);
      }
    }

    if (prevReduxProps.printLogs !== printLogs) {
      this.setState({ printLogs: printLogs?.printLogs });
    }
  }

  setChecks = (checks, deletedChecks) => {
    if (checks) {
      const allChecks = Array.from(checks.values());
      allChecks && allChecks.forEach(check => {
        this.checks.set(check.id, FBCommonUtil.parseCheckFromRedis(check));
      });
      if (deletedChecks && deletedChecks.length > 0) {
        deletedChecks.forEach(checkId => {
          this.checks.delete(checkId);
        });
      }
      this.toggleSelection(true);
    }
  };

  handleNewNotification = newNotifications => {
    const {
      dispatchUpdateNotification, context,
      reduxProps: { notifications, notificationsTypesPersist },
    } = this.props;
    const { updateNotification } = context;

    newNotifications.forEach(res => {
      const { notificationControlEnabled } = this.state;
      const tempNotifications = [...notifications];
      let isNew = false;
      const notificationTimes = new Date().toISOString();
      let enabled = notificationControlEnabled;
      const activeNotificationFilter = notificationsTypesPersist?.data?.activeNotificationFilter;
      if (
        res.new_val &&
        activeNotificationFilter !== null &&
        activeNotificationFilter !== undefined &&
        notificationsTypesPersist.data[activeNotificationFilter].length > 0
      ) {
        const dataType = this.getOrderTypeValue(activeNotificationFilter, res.new_val);
        if (!notificationsTypesPersist.data[activeNotificationFilter].includes(dataType)) {
          return;
        }
      }

      switch (res.type) {
        case "add":
        case "initial":
        case "update":
        case "change": {
          if (res.value.notificationTypeId === 16) {
            this.setOrderTypeStatus(res.value);
          }
          const notificationIndex = tempNotifications.findIndex(
            (notification) =>
              notification.notificationId === res.value.notificationId
          );
          let updatedValue;
          if (notificationIndex !== -1) {
            if (res.value.notificationTypeId === 18) {
              updatedValue = {
                ...res.value,
                isNew: tempNotifications[notificationIndex].isNew || false,
                isDismissed:
                  tempNotifications[notificationIndex].isDismissed || false,
                notificationTimes:
                  tempNotifications[notificationIndex].notificationTimes ||
                  notificationTimes,
                printStatus: tempNotifications[notificationIndex].printStatus || '',
                printerName: tempNotifications[notificationIndex].printerName || '',
                printTime: tempNotifications[notificationIndex].printTime || '',
              };
            } else {
              updatedValue = {
                ...res.value,
                isNew: tempNotifications[notificationIndex].isNew || false,
                isDismissed:
                  tempNotifications[notificationIndex].isDismissed || false,
                notificationTimes:
                  tempNotifications[notificationIndex].notificationTimes ||
                  notificationTimes,
              };
            }
            tempNotifications.splice(notificationIndex, 1, updatedValue);
          } else {
            // Vibration.vibrate(VIBRATION_PATTERN, REPEAT_VIBRATION);
            // setTimeout(() => {
            //   Vibration.cancel();
            // }, 10000);
            isNew = true;
            enabled =
              res.value.notificationTypeId !==
              NotificationType.SERVER_APP_PRINTER;
            clearInterval(this.snoozeTimeInterval);
            if (res.value.notificationTypeId === 18) {
              updatedValue = {
                ...res.value,
                isNew,
                isDismissed: false,
                notificationTimes,
                printStatus: 'Print Pending',
              };
              tempNotifications.push(updatedValue);
            } else {
              updatedValue = {
                ...res.value,
                isNew,
                isDismissed: false,
                notificationTimes,
              };
              tempNotifications.push(updatedValue);
            }
          }
          break;
        }
        default:
          console.info("notification type not handled", res.type);
      }

      this.state.notificationControlEnabled = enabled;
      this.state.snoozeEnabled = false;
      dispatchUpdateNotification(tempNotifications);
      updateNotification && updateNotification(res.value.notificationId);
      this.notificationTimeout && clearTimeout(this.notificationTimeout);
      this.notificationTimeout = setTimeout(() => {
        this.notificationTimestamp = new Date().getTime();
      }, 50);
    });
  };

  handleLoginAction = reduxProps => {
    const { reduxProps: prevReduxProps } = this.props;
    const { login } = reduxProps;
    if (login.timestamp !== prevReduxProps.login.timestamp) {
      if (login.data) {
        if (this.allowPairWatch) {
          this.setState({ loginInfo: login.data, popup: { type: "pairWatch" } });
          this.allowPairWatch = false;
          return;
        }
        this.setState({
          managerMode: true,
          selectedItem: {},
          items: [],
          popup: undefined,
        });
      } else if (login.error) {
        this.allowPairWatch = false;
        const popup = getPopupConfig('error', () => this.setState({ popup: undefined }));
        popup.message = login.error;
        this.setState({ popup });
      } else {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.loginLoadingHeading;
        this.setState({ popup });
      }
    }
  };

  reSync = () => {
    const callback = () => {
      this.getPopup('spinner', constants.sync, null);
      this.unsubscribeRethinkListeners();
      this.onIntialize = DBManager.addListener('initialize', this.reSync);
      this.checks = new Map();
      this.notificationsMap = new Map();
      const successCallback = () => {
        this.setState({ popup: undefined });
      };
      EventEmitter.addLogs(
        'syncLogs',
        LogLevelEnum.INFO,
        'Syncing with your POS'
      );
      this.getDataFromRedis(successCallback);
    };
    callback();
  };

  unsubscribeRethinkListeners = () => {
    this.onIntialize && this.onIntialize();
    this.notificationSubscriber && this.notificationSubscriber();
    this.notificationSubscriberMap.forEach((subscriber) => {
      subscriber && subscriber();
    });
    this.checkSubscriber && this.checkSubscriber();
    this.checkSubscriberMap.forEach((subscriber) => {
      subscriber && subscriber();
    });
  };

  getVenueInfo = (extId) => {
    API.getVenueInfo(extId).then(response => {
      console.debug("venueInfo", response);
      const stores = response.data.saStoreInfos;
      this.setState({ multipleStores: stores });
      console.log("multipleStores", stores);
      if (window.ReactNativeWebView) {
        EventEmitter.sendVenueInfo(response.data.name);
      }
    }).catch(error => {
      console.info("error in getting venue info", error);
      this.handleErrorPopup(error);
    })
  }


  getOrderType = (orderTypes) => {
    let setOrderType = orderTypes;
    if (orderTypes.length === 0) {
      setOrderType = [allOrderType.name];
    }

    return setOrderType;
  };

  setOrderType = (sourceTypes = [], callback) => {
    const orderType = this.getOrderType(sourceTypes);
    this.setState(
      {
        orderType: orderType && orderType.length > 0 ? orderType[0] : "",
      },
      () => callback && callback()
    );
  };


  setNotificationType = (notificationType, callback) => {
    this.setState(
      {
        notificationType,
      },
      () => callback && callback(),
    );
  };

  getDataFromRedis = (callback) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;

    this.getAllChecks(callback);

    this.getNotifications((error, response) => {
      if (error) {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.ERROR,
          "Get notifications errored out"
        );
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        this.getPopup("error", null, errorMsg);
        return;
      }
      this.notificationTimeout && clearTimeout(this.notificationTimeout);
      this.notificationTimestamp = new Date().getTime();
      response && response.forEach((n) => {
        this.notificationsMap.set(n.id, n);
      });
      EventEmitter.addLogs(
        'syncLogs',
        LogLevelEnum.INFO,
        `Response from Get notifications.`
      );

      const allNotifications = Array.from(this.notificationsMap.values());
      allNotifications &&
        allNotifications.forEach((n) => {
          n.printStatus = n.notificationTypeId === 18 ? n.acknowledged ? "Printed" : "Not Printed" : "";
          n.notificationId = n.id;
          const existingNotification = notifications
            ? notifications.find(
              (eachNotification) =>
                eachNotification.notificationId === n.notificationId
            )
            : null;
          if (existingNotification) {
            n.isNew = existingNotification.isNew;
            n.isDismissed = existingNotification.isDismissed;
            n.notificationTimes =
              existingNotification.notificationTimes ||
              new Date().toISOString();
          } else {
            n.isNew = false;
            n.isDismissed = false;
            n.notificationTimes = new Date().toISOString();
          }
        });
      dispatchUpdateNotification(allNotifications);
    });
  };

  setOrderTypeStatus = (notification) => {
    if (notification.sourceType === SourceTypes.CurbSide) {
      this.state.countStatus.curbside = notification.sourceTypeEnabled;
    } else if (notification.sourceType === SourceTypes.Online) {
      this.state.countStatus.online = notification.sourceTypeEnabled;
    } else if (notification.sourceType === SourceTypes.WalkUp) {
      this.state.countStatus.walkup = notification.sourceTypeEnabled;
    }
  };

  getOrderTypeValue = (type, response) => {
    let dataType = "";
    if (response.data) {
      if (type === "sourceType") {
        dataType = FireboardUtils.getNotificationSourceType(
          response.data.sourceType
        );
      } else if (type === "orderType") {
        const orderId = response.orderTypeId;
        dataType = this.getOrderTypeName(orderId);
      } else {
        const revenueId = response.revenueCenterId;
        dataType = this.getRevenueCenterName(revenueId);
      }
    }
    return dataType;
  };

  getOrderTypeName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const orderTypeDetails = storeInfo.data.orderTypes.find(
      (each) => each.id === id
    );
    if (orderTypeDetails) {
      return orderTypeDetails.name;
    }
    return "";
  };

  getRevenueCenterName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const revenueCenterDetails = storeInfo.data.revenueCenters.find(
      (each) => each.id === id
    );
    if (revenueCenterDetails) {
      return revenueCenterDetails.name;
    }
    return "";
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  removeNewTag = (itemData) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;
    const newNotifications = notifications.map((n) => {
      if (n.notificationId === itemData.id) {
        return { ...n, isNew: false };
      }
      return { ...n };
    });
    dispatchUpdateNotification(newNotifications);
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
  };

  getAllChecks = (callback) => {
    const { isMultiPrint, multipleStores } = this.state;
    const {
      reduxProps: { storeInfo },
    } = this.props;
    const { id: storeId, name: storeName } = storeInfo.data;

    if (isMultiPrint) {
      multipleStores.forEach((s) => {
        const sub = this.checkSubscriberMap.get(s.id);
        sub && sub();
        this.getStoreChecks(s.id, s.name, callback);
      });
    } else {
      this.getStoreChecks(storeId, storeName, callback);
    }
  };

  getStoreChecks = (storeId, storeName, callback) => {
    DBManager.getStoreChecks(storeId, (error, response) => {
      if (error) {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.ERROR,
          "Get store checks errored out"
        );
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        this.getPopup("error", null, errorMsg);
      } else {
        // clearTimeout(this.syncTimeout);
        response.forEach((check) => {
          this.checks.set(check.id, {
            ...FBCommonUtil.parseCheckFromRedis(check),
            storeName: storeName,
            storeId: storeId,
          });
        });
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.INFO,
          `Response from get store checks.`
        );
        callback && callback();
        this.setState(
          {
            isFetching: false,
          },
          () => {
            this.toggleSelection(true);
          }
        );
      }
    });
  }

  getNotifications = (callback) => {
    const { isMultiPrint, multipleStores } = this.state;
    const {
      reduxProps: { storeInfo },
    } = this.props;
    const { id: storeId } = storeInfo.data;

    if (isMultiPrint) {
      multipleStores.forEach((s) => {
        DBManager.getStoreNotifications(s.id, callback);
      });
    } else {
      DBManager.getStoreNotifications(storeId, callback);
    }
  };

  onOpenSearchBox = () => {
    this.setState({ showSearchBox: true });
  };

  resetFilterCalendar = () => {
    // this.onDateChange(null);
    const orderTypes = this.getOrderTypes();
    this.setState({
      orderStatusType: constants.orderInProgress,
      orderType: orderTypes[0],
      selectedDate: null
    }, () => this.toggleSelection())
  }

  onSearchReset = () => {
    this.setState({ value: "", showSearchBox: false }, () =>
      this.renderFilteredChecks("")
    );
  };

  searchChecks = () => {
    const { value } = this.state;
    this.renderFilteredChecks(value);
  };

  toggleSelection = (disableScroll, callback) => {
    const { orderType, orderStatusType, value } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, storeTypesPersist } = reduxProps;
    const checkList = FBCommonUtil.getChecksList(
      this.checks,
      orderType,
      storeInfo,
      storeTypesPersist.data.activeCheckFilter
    );

    let filteredChecksList = FBCommonUtil.getPrintServerChecksBasedOnFilters(
      checkList,
      orderStatusType,
      orderType
    );
    if (storeTypesPersist.data.activeCheckFilter === "sourceType") {
      if (orderType === constants.orderType_Table) {
        filteredChecksList = filteredChecksList.filter((check) => !check.tab);
      } else if (orderType === constants.orderType_Tab) {
        filteredChecksList = filteredChecksList.filter((check) => check.tab);
      }
    }
    this.filteredCheckItems = filteredChecksList;
    this.renderFilteredChecks(value);
    this.setState(
      {
        isFetching: false,
      },
      () => {
        if (disableScroll) {
          callback && callback();
          return;
        }
        // this.scrollToSection(0);
      }
    );
  };

  renderFilteredChecks = (value) => {
    const { orderStatusType } = this.state;
    let list = this.filteredCheckItems;
    if (orderStatusType === constants.futureOrder) {
      list = this.futureCheckItems;
    }
    const newFilteredChecklist =
      list && list.filter((check) => {
        if (
          (check.phoneNumber &&
            check.phoneNumber.toLowerCase().includes(value.trim())) ||
          (check.checkNumber &&
            check.checkNumber.toLowerCase().includes(value.trim())) ||
          (check.checkInNote &&
            check.checkInNote
              .toLowerCase()
              .includes(value && value.toLowerCase().trim())) ||
          (check.stationName &&
            check.stationName
              .toLowerCase()
              .includes(value && value.toLowerCase().trim()))
        ) {
          return check;
        }
      });
    const checksSortedByOpenDate = this.sortArrayByKey(newFilteredChecklist, 'dueTime');

    this.setState({
      filteredChecklist: checksSortedByOpenDate,
    });
  };

  retry = (error, callback) => {
    const popup = getPopupConfig('error', () => {
      this.setState({ popup: undefined });
    });
    popup.message = error;
    popup.buttons = [
      {
        text: constants.cancelText,
        onPress: () => {
          this.setState({ popup: undefined });
        },
      },
      {
        text: constants.retry,
        onPress: () => {
          this.setState({ popup: undefined });
          callback && callback();
        },
      },
    ];
    this.setState({ popup });
  };

  setSelectedCheck = (item) => {
    let items = item && item.items;
    let pendingCheckItems = [];
    const isPOSOrder =
      FBCommonUtil.getOrderTypeFromSourceType(item.sourceType) ===
      constants.orderType_POS;

    const check = this.checks.get(item.id);
    const { context } = this.props;
    const { acknowledgeCheck } = context;
    acknowledgeCheck && acknowledgeCheck(check.checkHeaderId);
    // const check = posCheck;

    if (isPOSOrder) {
      items = FireboardUtils.updatePOSItems(item);
      const pendingItems = MenuUTIL.getPendingItemsFromCheck(item);
      pendingCheckItems = FireboardUtils.updatePendingPOSItems(pendingItems, item);
    }

    const selectedItem = item;
    const { filteredChecklist } = this.state;
    this.checks.forEach((check, checkHeaderId) => {
      const selectedCheck = this.checks.get(item.id);
      if (selectedCheck && checkHeaderId === selectedCheck.checkHeaderId) {
        this.checks.set(checkHeaderId, {
          ...check,
          isNew: false,
          paidAmountChanged: false,
          deliverToChanged: false,
        });
      }
    });
    let newFilteredChecklist = [...filteredChecklist];
    if (item.isNew || item.paidAmountChanged || item.deliverToChanged) {
      newFilteredChecklist = filteredChecklist.map((check) => {
        const selectedCheck = this.checks.get(item.id);
        if (selectedCheck && check.checkHeaderId === selectedCheck.checkHeaderId) {
          return {
            ...check,
            isNew: false,
            paidAmountChanged: false,
            deliverToChanged: false,
          };
        }
        return { ...check };
      });
    }
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
    this.setState({
      items,
      pendingCheckItems,
      selectedItem,
      filteredChecklist: newFilteredChecklist,
    });
  };

  getFutureOrdersList = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const currentDate = new Date().setHours(0, 0, 0, 0);
    const { latitude, longitude } = UTILLib.location;
    API.getFutureOrdersList({
      latitude,
      longitude,
      storeId: storeInfo.data.id,
    })
      .then((res) => {
        this.setState({
          popup: undefined,
          futureOrdersList: res.data,
          selectedItem: {},
          items: [],
          selectedDate: currentDate,
        }, () => this.onDateChange(currentDate));
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  headerPress = (type, value) => {
    switch (type) {
      case NOTIFICATION: {
        clearInterval(this.snoozeTimeInterval);
        this.setState(
          (prevState) => ({
            selectedItem: {},
            items: [],
            showNotifications: !prevState.showNotifications,
            notificationControlEnabled: false,
            snoozeEnabled: false,
            cashPayFlag: false,
            customTextToPay: false,
            isPayNow: false,
            isCheckInRequest: false,
            filteredChecklist: [],
          }),
          () => {
            const { showNotifications } = this.state;
            if (!showNotifications) {
              this.toggleSelection();
            }
          }
        );
        break;
      }
      case ORDER_TYPE: {
        this.setState(
          {
            orderType: value,
            selectedItem: {},
            items: [],
            showNotifications: false,
            customTextToPay: false,
            filteredChecklist: [],
            showAllChecksEnabled: false,
          },
          () => this.toggleSelection()
        );
        break;
      }
      case STATUS_TYPE: {
        this.setState(
          {
            orderStatusType: value,
            selectedItem: {},
            items: [],
            showNotifications: false,
            customTextToPay: false,
            filteredChecklist: [],
          },
          () => {
            if (value === constants.futureOrder) {
              this.getFutureOrdersList();
            }
            this.toggleSelection();
          }
        );
        break;
      }
      default: {
        console.debug("unhandled iconPress", type, value);
        break;
      }
    }
  };

  onHandleSend = (msg) => {
    const { selectedItem, selectedCountry } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, currencyInfo: { iso2 } } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const popup = getPopupConfig("error");
    popup.heading = constants.confirmationMessage;
    const phoneNumberForSMS = FireboardUtils.formattedPhoneNumber(selectedItem.selectedCheckDetails.phoneNumber || "", iso2);
    popup.message = constants.sendSmsPopupMsg;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => {
          this.setState({ popup: undefined });
        },
      },
      {
        text: constants.yes,
        onClick: () => {
          this.getPopup("spinner", constants.smdSendLoaderHeading, null);
          const { latitude, longitude } = UTILLib.location;
          API.fireboardSendSMS({
            latitude,
            longitude,
            deviceId: deviceId,
            storeId: storeInfo.data.id,
            phoneNumber: selectedItem.selectedCheckDetails.phoneNumber || null,
            countryCode: selectedCountry.dialCode.split('+')[1],
            message: msg,
            checkHeaderId: selectedItem?.checkHeaderId || selectedItem?.id,
          })
            .then((resp) => {
              console.debug("responsee from sms api", resp);
              this.dismissPopup();
              FireboardUtils.addNetworkLogs(resp);
            })
            .catch((error) => {
              console.debug("error from sms api", error, error.response);
              this.handleErrorPopup(error);
            });
        },
      },
    ];
    this.setState({ popup });
  };

  generateQR = (item) => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.GENERATE_QR,
        meta: item,
      },
    });
  };

  getEllapsedTime = (check) => {
    const time = check.elapsedTime;
    if (!time || time < 0) {
      return "- -";
    }
    const convertedTimeInSeconds = parseInt(time / TimeConstants.SECOND);
    if (convertedTimeInSeconds < 60)
      return `${UTIL.round(convertedTimeInSeconds, 0)}s`;
    const convertedTimeInMinutes = convertedTimeInSeconds / 60;
    if (convertedTimeInMinutes < 120)
      return `${UTIL.round(convertedTimeInMinutes, 0)}m`;

    return "2h+";
  };

  getRelatedNotificationsForCheck = (check, notifications) => {
    const relatedNotifications = notifications.filter(
      n => n.data.checkHeaderId === check.id,
    );
    return relatedNotifications;
  }

  getPrintNotifications = () => {
    const { reduxProps } = this.props;
    const { notifications } = reduxProps;
    let notificationsToBeDisplayed = notifications.filter(
      n => !n.isDismissed && n.notificationTypeId === 18,
    );
    return notificationsToBeDisplayed;
  }

  get checksRowData() {
    const { reduxProps: { currencyInfo } } = this.props;
    const { iso2 } = currencyInfo || {};
    const { selectedItem, filteredChecklist } = this.state;
    const notificationsToBeDisplayed = this.getManagerNotifications();
    const rowData =
      Array.isArray(filteredChecklist) &&
      filteredChecklist.length &&
      filteredChecklist.map((check) => {
        const relatedNotifications = this.getRelatedNotificationsForCheck(check, notificationsToBeDisplayed);
        const { paidIcon, preAuthIcon } = FireboardUtils.getPaidStatusIcon(check, this.currency);
        const { status, color } = FireboardUtils.getOrderNameFromOrderId(check);
        return {
          isNew: check.isNew,
          printStatus: check.printStatus,
          printerName: check.printerName,
          printTime: check.printTime,
          openDate: check.openDate ? FireboardUtils.getTimeInHrsMins(check.openDate) : '- -',
          relatedNotifications: relatedNotifications,
          phoneNumber: check.phoneNumber
            ? FireboardUtils.formattedPhoneNumber(check.phoneNumber, iso2)
            : "- -",
          storeName: check.storeName || "- -",
          checkNumber: `[${check.checkNumber}]` || "- -",
          checkInTime: FireboardUtils.getCheckInTime(check),
          dueTime: FireboardUtils.getTimeInHrsMins(check.dueTimeDisplay),
          dueTimeForSorting: new Date(check.dueTimeDisplay).getTime(),
          deliverTo: FireboardUtils.getDeliverTo(check),
          sourceType: check.sourceType,
          paid: preAuthIcon || paidIcon,
          ellapsedTime: this.getEllapsedTime(check),
          status: status,
          color: color,
          items: check.items,
          id: check.id,
          selectedCheckDetails: check,
          orderStatusId: check.orderStatusId,
          unpaidAmount: check.unpaidAmount,
          paidAmount: check.paidAmount,
          pickupDate: check.pickupDate,
          checkHeaderId: check.checkHeaderId,
          referenceId: check.referenceId,
          guestName: check.guestName,
          totalAmount: check.totalAmount,
          onHandleCheckActions: this.onHandleCheckActions,
          orders: check.orders,
          seats: check.seats,
          tickets: check.tickets,
          stationId: check.stationId,
          open: check.open,
          paidAmountChanged: check?.paidAmountChanged || false,
          deliverToChanged: check?.deliverToChanged || false,
          rowSelected: check.id === selectedItem.id,
          highlightRow: relatedNotifications && relatedNotifications.length > 0,
        };
      });
    return rowData ? rowData.filter(each => each !== null) : [];
  }

  getTime = (notification) =>
    notification.notificationTimes !== null &&
      notification.notificationTimes !== undefined
      ? FireboardUtils.getTimeInHrsMins(notification.notificationTimes)
      : "--";

  sortNotifications = (notifications) => {
    const sortKey = "notificationId";
    return notifications.sort((n1, n2) => n2[sortKey] - n1[sortKey]);
  };

  getSelectedNotificationTypeIds = () => {
    const { reduxProps } = this.props;
    const { storeTypesPersist, storeInfo } = reduxProps;
    const { notificationTypes = [] } = storeInfo.data || {};
    const selectedNotifications = storeTypesPersist.data.notificationTypes
      ? storeTypesPersist.data.notificationTypes
      : [];
    const nTypeIds = [];
    selectedNotifications.forEach(sn => {
      const n = notificationTypes.find(nt => nt.name === sn);
      if (n) nTypeIds.push(n.id);
    });
    return nTypeIds;
  };

  getNotificationsToBeDisplayed = () => {
    const { reduxProps } = this.props;
    const { managerMode } = this.state;
    const { notifications, notificationsTypesPersist, storeTypesPersist } = reduxProps;
    let notificationsToBeDisplayed = notifications;
    const selectedNotifications = storeTypesPersist.data.notificationTypes
      ? storeTypesPersist.data.notificationTypes
      : [];
    const activeNotificationFilter =
      notificationsTypesPersist.data.activeNotificationFilter;
    if (managerMode) {
      return notifications.filter(n => n.notificationTypeId === 14 || n.notificationTypeId === 15);
    }
    if (selectedNotifications.length > 0) {
      const selectedIds = this.getSelectedNotificationTypeIds();
      notificationsToBeDisplayed = notifications.filter(
        notification => selectedIds.includes(notification.notificationTypeId) &&
          !notification.dismissed &&
          notification.notificationTypeId !== 15,
      );
      if (selectedIds.includes(9)) {
        notificationsToBeDisplayed = notificationsToBeDisplayed.filter(r => {
          const sourceType = this.getOrderTypeValue(activeNotificationFilter, r);
          return (
            (notificationsTypesPersist.data[activeNotificationFilter].length === 0 ||
              notificationsTypesPersist.data[activeNotificationFilter].includes(sourceType)) &&
            r.notificationTypeId !== NotificationType.SURVEY_POSTED &&
            r.notificationTypeId !== NotificationType.SERVER_APP_PRINTER &&
            !r.isDismissed
          );
        });
      }
    } else {
      notificationsToBeDisplayed = notifications.filter(
        n => !n.isDismissed && n.notificationTypeId !== 15,
      );
    }
    return notificationsToBeDisplayed;
  }

  get notificationsData() {
    const notificationsToBeDisplayed = this.getNotificationsToBeDisplayed();
    const sortedNotifications = this.sortNotifications(
      notificationsToBeDisplayed
    );
    const { managerMode } = this.state;

    const rowData =
      Array.isArray(sortedNotifications) &&
      sortedNotifications.length &&
      sortedNotifications.map((notification) => {
        return {
          sourceType:
            notification && notification.data && notification.data.sourceType,
          isNew: notification.isNew,
          time: this.getTime(notification),
          message: notification.note,
          ack: true,
          dismiss: true,
          goAndDismiss: true,
          notificationGoAndDismiss: this.notificationGoAndDismiss,
          dismissNotification: this.dismissNotification,
          ackNotification: this.ackNotification,
          acknowledgeIdCheck: this.acknowledgeIdCheck,
          // acknowledgeOverServe: this.acknowledgeOverServe,
          notification: notification,
          goToCheck: this.goToCheck,
          managerMode,
        };
      });
    return rowData;
  }

  joinCheck = item => {
    const { sensorData } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    if (sensorData && sensorData.externalId) {
      this.setState({
        popup: {
          type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
          meta: item,
          sensorData: sensorData,
        },
      });
    } else {
      API.sensorCode({
        storeId: storeInfo.data.id,
        stationId: item.stationId,
      })
        .then((resp) => {
          console.debug("responsee from joinCheck api", resp);
          this.setState({
            sensorData: resp.data,
            popup: {
              type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
              meta: item,
              sensorData: resp.data,
            },
          });
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => {
          console.debug("error from joinCheck api", error, error.response);
          this.handleErrorPopup(error);
        });
    }
  }

  updateOrderStatus = (item, type) => {
    let orderStatusId;
    if (type === "done") {
      // TODO: add enums
      orderStatusId = 5;
      this.dispatchOrderStatus(item.selectedCheckDetails, orderStatusId);
    } else if (type === "cancel") {
      const popup = getPopupConfig("success");
      popup.heading = constants.orderCancellation;
      popup.message = constants.cancelCheckHeading;
      popup.buttons = [
        {
          text: constants.no,
          onClick: () => {
            this.setState({ popup: undefined });
          },
        },
        {
          text: constants.yes,
          onClick: () => {
            this.cancelOrder(item.selectedCheckDetails);
          },
        },
      ];
      this.setState({ popup });
    } else if (type === "moveToInprogress") {
      const popup = getPopupConfig("error");
      popup.heading = constants.futureToIPHeader;
      popup.message = constants.futureToIPMessage;
      popup.buttons = [
        {
          text: constants.noCaps,
          onClick: () => this.setState({ popup: undefined }),
        },
        {
          text: constants.yesCaps,
          onClick: () => {
            orderStatusId = 1;
            this.dispatchOrderStatus(item.selectedCheckDetails, orderStatusId);
          },
        },
      ];
      this.setState({ popup });
    }
  };

  cancelOrder = (item) => {
    const orderStatusId = 8;
    this.dispatchOrderStatus(item, orderStatusId);
  };

  dispatchOrderStatus = (item, orderStatusId) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    API.orderStatusUpdate({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      checkHeaderId: item.id,
      orderStatusId,
    })
      .then((response) => {
        console.debug("response from orderStatusUpdate", response);
        this.checks.set(response.data.checkHeaderId, response.data);

        //future order- check need to be remove when status get changed 
        const { orderStatusType } = this.state;
        if (orderStatusType === constants.futureOrder) {
          const newfutureCheckItems = this.futureCheckItems.filter(it => it.checkHeaderId !== response.data.checkHeaderId);
          this.futureCheckItems = newfutureCheckItems;
        }
        this.toggleSelection(true);
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        this.handleErrorPopup(error);
      });
  };

  printCheck = (item) => {
    const { dispatchPrintAction, reduxProps } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { id } = item || {};
    dispatchPrintAction({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      employeeId: 0,
      checkHeaderId: id,
      seatIds: [],
      employeeCard: reduxProps.employee ? reduxProps.employee.loginId : null,
    });
  };

  onHandleSms = () => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.SMS,
      },
    });
  };

  onHandleTextToPay = (item, fromFooter) => {
    this.setState({ popup: { type: "textToPay", meta: item }, fromFooter, });
  };

  textToCheckIn = (item, fromFooter) => {
    this.setState({ popup: { type: "checkIn", meta: item }, fromFooter, });
  };

  onHandleCheckActions = () => {
    this.setState({ popup: { type: "check-options" }, });
  }

  markItemAPaid = (item) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    API.orderStatusPaid({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      checkHeaderId: item.id,
    })
      .then((response) => {
        console.debug("response from orderStatusPaid", response);
        this.checks.set(response.data.checkHeaderId, response.data);
        this.toggleSelection(true);
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        this.handleErrorPopup(error);
      });
  };

  onFooterIconPress = (type, fromFooter) => {
    switch (type) {
      case "sort": {
        this.setState({ popup: { type: "sort" }, selectedItem: {}, });
        break;
      }
      case "textToPay": {
        this.setState({ popup: { type: "textToPay" }, selectedItem: {}, fromFooter: true });
        break;
      }
      case "payNow": {
        this.setState({ popup: { type: "payNow" }, selectedItem: {}, });
        break;
      }
      case "checkIn": {
        this.setState({ popup: { type: "checkIn" }, fromFooter: true, selectedItem: {}, });
        break;
      }
      case "settings": {
        this.setState({ popup: { type: "settings" }, selectedItem: {}, });
        break;
      }
      case "channels": {
        this.setState({ popup: { type: "channels" }, selectedItem: {}, });
        break;
      }
      case "about": {
        this.setState({ popup: { type: "about", }, selectedItem: {}, });
        break;
      }
      case "diagnostics": {
        this.setState({ popup: { type: "diagnostics", }, selectedItem: {}, });
        break;
      }
      case "outOfStock": {
        this.setState({ popup: { type: "outOfStock" }, selectedItem: {}, });
        break;
      }
      case "pairWatch": {
        this.setState({ popup: { type: "pairWatch" }, selectedItem: {}, loginInfo: null });
        break;
      }
      case "managerLogin": {
        this.setState({ popup: { type: "managerLogin" }, selectedItem: {}, });
        break;
      }
      case "networkLogs": {
        this.setState({ popup: { type: "networkLogs" }, selectedItem: {}, });
      }
      default: {
        console.warn("popup type unhandled", type);
      }
    }
  };

  sortArrayByKey = (array, key) => {
    const { sortFilter } = this.state;
    const lowToHigh = array.sort(function (a, b) {
      const first = a[key];
      const second = b[key];
      return ((first < second) ? -1 : ((first > second) ? 1 : 0));
    });
    return sortFilter ? lowToHigh.reverse() : lowToHigh;
  }

  setSortType = () => {
    const { sortFilter } = this.state;
    this.setState(
      {
        sortFilter: !sortFilter,
      },
      () => {
        const { dispatchUpdateCheckSort } = this.props;
        const { sortFilter, filteredChecklist } = this.state;
        this.sortArrayByKey(filteredChecklist, 'dueTime');
        dispatchUpdateCheckSort({ sortFilter });
      },
    );
  }

  setCounterType = (counter, callback) => {
    this.setState(
      {
        counters: counter,
      },
      () => callback && callback(),
    );
  };

  onSaveFilter = (
    activeCheckFilter,
    orderTypes,
    sourceTypes,
    revenueTypes,
    orderTypeNotifications,
    sourceTypeNotifications,
    revenueTypeNotifications,
    notificationTypesList,
    counters,
  ) => {
    const {
      dispatchUpdateStatusType,
      dispatchUpdateNotificationType,
    } = this.props;
    dispatchUpdateStatusType({
      orderTypes,
      sourceTypes,
      revenueTypes,
      activeCheckFilter,
      notificationTypes: notificationTypesList,
      counterTypes: counters,
    });
    dispatchUpdateNotificationType({
      orderType: orderTypeNotifications,
      sourceType: sourceTypeNotifications,
      revenueCenter: revenueTypeNotifications,
      activeNotificationFilter: activeCheckFilter,
    });

    this.setNotificationType(notificationTypesList);

    if (activeCheckFilter === 'sourceType') {
      this.setOrderType(sourceTypes, this.toggleSelection);
    } else if (activeCheckFilter === 'revenueCenter') {
      this.setOrderType(revenueTypes, this.toggleSelection);
    } else if (activeCheckFilter === 'orderType') {
      this.setOrderType(orderTypes, this.toggleSelection);
    }
    this.setState({ popup: undefined });
  };

  getToggleType = (type) => {
    switch (type) {
      case "curbside":
        return "Curbside";
      case "online":
        return "Online";
      case "walkup":
        return "Walkup";
      default:
        return "";
    }
  };

  getSourceTypeFromOrderType = (type) => {
    switch (type) {
      case "curbside":
        return 5;
      case "online":
        return 6;
      case "callIn":
        return 8;
      case "walkup":
        return 7;
      default:
        break;
    }
  };

  invokeDisableOrder = (type) => {
    const { countStatus } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.channelChangeLoader, null);

    API.disableOrders({
      latitude: 0,
      longitude: 0,
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      sourceType: this.getSourceTypeFromOrderType(type),
      enabled: !countStatus[type],
    })
      .then((response) => {
        console.debug("response from channelStatus", response);
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.debug("error from disabling order", error, error.response);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        FireboardUtils.addNetworkLogs(error.response);
        this.retry(errorMsg, () => {
          this.invokeDisableOrder(type);
        });
      });
  };

  onToggleCount = (type) => {
    if (type === "prepTime" || type === "productionRate") {
      this.setState({
        popup: {
          type,
        },
      });
      return;
    }
    const { countStatus } = this.state;
    const popup = getPopupConfig("error");
    const enabled = countStatus[type];
    popup.heading = `${enabled ? "Disable" : "Enable"} ${this.getToggleType(
      type
    )} Orders`;
    if (enabled) {
      popup.message = `This will stop accepting ${type} orders. Would you like to proceed?`;
    } else {
      popup.message = `This will start accepting ${type} orders. Would you like to proceed?`;
    }
    popup.buttons = [
      {
        text: "No",
        onClick: () => this.setState({ popup: undefined }),
      },
      {
        text: "Yes",
        onClick: () => this.invokeDisableOrder(type),
      },
    ];
    this.setState({ popup });
  };

  onUpdate = (type, value) => {
    const {
      reduxProps: { storeInfo },
    } = this.props;
    if (type === "prepTime") {
      this.getPopup("spinner", "Updating Preparation Time", null);
      API.updatePrepTime({ prepWindow: value, storeId: storeInfo.data.id })
        .then((res) => {
          console.info("response from updatePrepTime", res);
          this.setState({ prepTime: value, popup: undefined });
          FireboardUtils.addNetworkLogs(res);
        })
        .catch((error) => this.handleErrorPopup(error));
    } else if (type === "productionRate") {
      this.getPopup("spinner", "Updating Production Rate", null);
      API.updateProdTime({ productionRate: value, storeId: storeInfo.data.id })
        .then((res) => {
          console.info("response from updateProdutionTime", res);
          this.setState({ productionTime: value, popup: undefined });
          FireboardUtils.addNetworkLogs(res);
        })
        .catch((error) => this.handleErrorPopup(error));
    }
  };

  closePopup = (event, callback = () => { }) => {
    this.requestClicked = false;
    this.setState({ popup: undefined, selectedItem: {} }, () => !!callback && callback());
  };

  dismissPopup = (event, callback = () => { }) => {
    this.setState({ popup: undefined }, () => !!callback && callback());
  }

  setNotifications = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showNotifications: !prevState.showNotifications,
        notificationControlEnabled: false,
        snoozeEnabled: false
      };
    });
  };

  dismissNotification = (notification) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;
    const notificationsCopy = notifications.slice();
    const notificationIndex = notificationsCopy.findIndex(
      (n) => n.notificationId === notification.notificationId
    );
    if (notificationIndex > -1) {
      notificationsCopy.splice(notificationIndex, 1, {
        ...notification,
        isDismissed: true,
      });
    }
    dispatchUpdateNotification(notificationsCopy);
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
  };

  ackNotification = (notification) => {
    const {
      reduxProps,
      dispatchAcknowledgeNotification,
      dispatchUpdateNotification,
    } = this.props;
    const { deviceApi, storeInfo } = reduxProps;
    const { id } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    if (notification.notificationTypeId === 16) {
      const { notifications } = reduxProps;
      const notificationsCopy = notifications.slice();
      const notificationIndex = notificationsCopy.findIndex(
        (n) => n.notificationId === notification.notificationId
      );
      if (notificationIndex !== -1) {
        notificationsCopy.splice(notificationIndex, 1, {
          ...notification,
          isDismissed: true,
        });
      }
      dispatchUpdateNotification(notificationsCopy);
    }
    const payload = {
      deviceId,
      storeId: id,
      notificationId: notification.notificationId,
    };
    dispatchAcknowledgeNotification(payload);
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
  };

  notificationGoAndDismiss = (notification) => {
    const { reduxProps } = this.props;
    const { storeTypesPersist } = reduxProps;
    const checkId = notification.data.checkHeaderId;
    const checkDetails = this.checks.get(checkId);
    if (checkDetails && Object.keys(checkDetails).length !== 0 && checkDetails.constructor === Object) {
      const orderStatusId = checkDetails.orderStatusId;
      const orderStatusType = FBCommonUtil.getOrderNameFromId(orderStatusId);
      const orderType = FBCommonUtil.getOrderTypeFromSourceType(
        checkDetails.sourceType
      );
      if (
        storeTypesPersist.data.sourceTypes.length === 0 ||
        storeTypesPersist.data.sourceTypes.includes(orderType)
      ) {
        this.ackNotification(notification);
        this.setState(
          {
            items: checkDetails.items,
            selectedItem: checkDetails,
            orderType,
            orderStatusType,
            showNotifications: false,
          },
          () => {
            this.toggleSelection(true, () => {
              const { filteredChecklist } = this.state;
              const index = filteredChecklist.findIndex(
                (check) => check.checkHeaderId === checkId
              );
              if (index > -1) {
                // this.scrollToSection(index);
              }
            });
          }
        );
      }
    }
  };

  goToCheck = notification => {
    const { reduxProps } = this.props;
    const { storeTypesPersist } = reduxProps;
    const checkId = notification.data.checkHeaderId;
    const checkDetails = this.checks.get(checkId);
    if (checkDetails) {
      const orderStatusId = checkDetails.orderStatusId;
      const orderStatusType = FBCommonUtil.getOrderNameFromId(orderStatusId);
      const orderType = FBCommonUtil.getOrderTypeFromSourceType(checkDetails.sourceType);
      if (
        storeTypesPersist?.data?.sourceTypes.length === 0 ||
        storeTypesPersist?.data?.sourceTypes.includes(orderType)
      ) {
        this.setState(
          {
            items: checkDetails.items,
            selectedItem: checkDetails,
            orderType,
            orderStatusType,
            showNotifications: false,
          },
          () => {
            this.setSelectedCheck(checkDetails);
            this.toggleSelection(true, () => {
              const { filteredChecklist } = this.state;
              const index = filteredChecklist.findIndex(check => check.checkHeaderId === checkId);
              if (index > -1) {
                // this.scrollToSection(index);
              }
            });
          },
        );
      }
    }
  };

  handleChange = (event) => {
    this.setState({ value: event.target.value });
  };

  getSpinner = (type: string, heading: any, message: any) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          this.closePopup();
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  // acknowledgeOverServe = (approved, notification, reason) => {
  //   this.getSpinner("spinner", constants.ackOverServe, null);
  //   const { reduxProps } = this.props;
  //   const { storeInfo, deviceInfo, login } = reduxProps;
  //   API.acknowledgeOverServe({
  //     deviceExternalId: deviceInfo.deviceExternalId,
  //     storeId: storeInfo.data.id,
  //     notificationId: notification.id,
  //     overServeReasonId: reason ? reason.id : null,
  //     approved,
  //     employeeId: login.data.id,
  //   })
  //     .then((response) => {
  //       console.info("response from acknowledgeOverServe", response);
  //       this.setState({ popup: undefined });
  //       FireboardUtils.addNetworkLogs(response);
  //     })
  //     .catch((error) => {
  //       console.debug("error from acknowledgeOverServe", error, error.response);
  //       this.handleErrorPopup(error);
  //     });
  // };

  acknowledgeIdCheck = (approved, notification) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getSpinner("spinner", constants.ackIdCheck, null);
    API.acknowledgeIdCheck({
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      notificationId: notification.id,
      approved,
      employeeId: login.data.id,
    })
      .then((response) => {
        console.info("response from acknowledgeIdCheck", response);
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.debug("error from acknowledgeIdCheck", error, error.response);
        this.handleErrorPopup(error);
      });
  };

  invokeTextToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { selectedItem } = this.state;
    const {
      phoneNumber,
      guestName,
      pickupTime,
      checkNumber,
      subTotal,
      tax,
      selectedCountry,
      preAuth,
    } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.textToPayGenLoader, null);
    API.generateTextToPay({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +subTotal,
      taxAmount: +tax,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId: selectedItem && selectedItem.checkHeaderId,
      preAuth: preAuth || false,
    })
      .then((response) => {
        console.debug("response from generateTextToPay", response);
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: this.dismissPopup,
          },
          {
            text: constants.retry,
            onClick: () => {
              this.dismissPopup(null, () => this.invokeTextToPay(payload));
            },
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  invokeCheckIn = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { selectedItem } = this.state;
    const { phoneNumber, guestName, pickupTime, checkNumber, selectedCountry, } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.checkInRequestLoader, null);
    API.checkInRequest({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +0,
      taxAmount: +0,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId: selectedItem && selectedItem.checkHeaderId,
    })
      .then((response) => {
        console.debug("response from checkInRequest", response);
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.warn(
          "error in generateTextToPay",
          error,
          error.request,
          error.response
        );
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: this.dismissPopup,
          },
          {
            text: constants.retry,
            onClick: () => {
              this.dismissPopup(null, () => this.invokeCheckIn(payload));
            },
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  generateQRPay = check => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.GENERATE_QR_PAY,
        meta: check,
      },
    });
  };

  invokeScanToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { amount, checkNumber } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.payNowLoader, null);
    API.payNow({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      guestName: null,
      phoneNumber: null,
      checkNumber,
      subtotalAmount: +amount,
      pickupTime: null,
    })
      .then((response) => {
        console.debug("response from payNow", response);
        this.generateQRPay(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.warn(
          "error in generateTextToPay",
          error,
          error.request,
          error.response
        );
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: this.dismissPopup,
          },
          {
            text: constants.retry,
            onClick: () => {
              this.dismissPopup(null, () => this.invokeScanToPay(payload));
            },
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  showMemberDetailPopup = (memberId) => {
    this.getPopup("spinner", "Getting member details...", null);
    API.getMemberDetails({ memberId })
      .then((res) => {
        this.setState({
          popup: {
            type: POPUPS_ENUMS.MEMBER_DETAILS,
            metaData: res.data,
          },
        });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  onPrintPress = (type, printMeta) => {
    const { selectedItem, items } = this.state;
    const { selectedCheckDetails } = selectedItem || {};
    const { storeId, number: checkNumber, id: checkId } = selectedCheckDetails || {};
    const {
      reduxProps: { storeInfo, deviceInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    if (selectedCheckDetails && Object.keys(selectedCheckDetails).length === 0) {
      return;
    }
    let requestBody;
    let requestType;
    let printType;
    if (type === 'check') {
      if (printMeta.display === 'GUEST RECEIPT') {
        if (selectedItem && Object.keys(selectedItem).length !== 0) {
          this.printCheck(selectedItem);
          this.setSelectedCheck(selectedItem);
          printType = 'Guest Receipt';
        }
        return;
      } else if (printMeta.display === 'FULL ORDER LABEL') {
        requestBody = {
          storeId: storeId,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
          includeItems: false,
        };
        requestType = 'printCheck';
        printType = 'Full Order Label';
      } else if (printMeta.display === 'ORDER + ITEMS LABELS') {
        requestBody = {
          storeId: storeId,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
          includeItems: true,
        };
        requestType = 'printCheck';
        printType = 'Order + Items';
      } else if (printMeta.display === 'INDIVIDUAL ITEM LABELS') {
        requestBody = {
          storeId: storeId,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
          checkItemIds: selectedCheckDetails && selectedCheckDetails.items.map(i => i.checkItemId),
        };
        requestType = 'printCheck';
        printType = 'Item Labels';
      } else if (printMeta.display === 'KITCHEN TICKET') {
        requestBody = {
          storeId: storeId,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.checkHeaderId,
        };
        requestType = 'printOrderTicket';
        printType = 'Kitchen Ticket';
      }
      this.getPopup('spinner', `Printing ${printMeta.display}`, null);
    } else if (type === 'item') {
      requestBody = {
        storeId: storeId,
        deviceId: deviceId,
        checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
        checkItemIds: [printMeta.checkItemId],
      };
      requestType = 'printItems';
      printType = 'Items';
      this.getPopup('spinner', 'Printing item', null);
    }
    API[requestType](requestBody)
      .then(response => {
        FireboardUtils.addNetworkLogs(response);
        console.info('response from print', response);
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = response.data.printerName
          ? `${constants.printLoading} at ${response.data.printerName}`
          : constants.printLoading;
        let updatedItems = [];
        const isPOSOrder =
          FBCommonUtil.getOrderTypeFromSourceType(selectedCheckDetails.sourceType) ===
          constants.orderType_POS;
        if (isPOSOrder) {
          if (type === 'item') {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => {
                  if (eachItem.id === printMeta.checkItemId) {
                    return {
                      ...eachItem,
                      printed: true,
                    };
                  }
                  return eachItem;
                });
              });
          } else {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => ({
                  ...eachItem,
                  printed: true,
                }));
              });
          }
        } else if (type === 'item') {
          updatedItems = items.map(eachItem => {
            if (eachItem.id === printMeta.checkItemId) {
              return {
                ...eachItem,
                printed: true,
              };
            }
            return eachItem;
          });
        } else {
          updatedItems = items.map(eachItem => ({
            ...eachItem,
            printed: true,
          }));
        }
        this.setState({ popup: printPopup, items: updatedItems });
        if (printType === 'Kitchen Ticket') {
          const { printJobs } = response.data;
          const printDataArray = Array.isArray(printJobs) ? printJobs : [];
          if (printDataArray.length > 0) {
            printDataArray.forEach(data =>
              this.printReceipt({
                type: 'print',
                data,
                printType,
              }, checkId, checkNumber)
            );
          } else {
            this.addPrintLog({
              checkId: checkId,
              checkNumber: checkNumber,
              printerName: null,
              printerIpAddress: null,
              status: 'SKIPPING PRINT CALL',
              printType: 'Kitchen Ticket',
            });
          }
        } else {
          var data = {
            type: "print",
            data: response.data,
            printType,
          };
          this.printReceipt(data, checkId, checkNumber);
        }
        setTimeout(() => {
          this.dismissPopup();
        }, 4000);
      })
      .catch(error => {
        console.debug('error', error, error.response);
        this.handleErrorPopup(error);
      });
  };

  printReceipt = (data, checkId, checkNumber) => {
    const { printerIpAddress, printerName, printerPort, bytes } = data?.data || {};
    const logData = {
      checkId,
      checkNumber,
      printerName,
      printerIpAddress,
      printType: data?.printType,
    };
    if (bytes) {
      UTILLib.printReceipt(
        data,
        () => {
          this.addPrintLog({ ...logData, status: 'SUCCESS' });
          this.dismissPopup();
        },
        error => {
          this.addPrintLog({ ...logData, status: 'FAILURE' });
          console.warn('error while printing receipt', error);
          const popup = getPopupConfig('error', () => {
            this.setState({ popup: undefined });
          });
          popup.message = "Trying to connect to " + printerName + " with IP Address " + printerIpAddress + " and port " + printerPort + " " + error;
          this.setState({ popup });
        },
        () => {
          this.addPrintLog({ ...logData, status: 'EXTENSION NOT AVAILABLE' });
          let popup = getPopupConfig('error', () => this.dismissPopup());
          popup.message = constants.extensionNotAvailable;
          this.setState({ popup });
        },
      );
    } else {
      this.addPrintLog({ ...logData, status: 'SKIPPING PRINT CALL' });
    }
  };

  addPrintLog = logData => {
    const { checkId, checkNumber, printerName, printerIpAddress, status, printType } = logData || {}
    const { dispatchAddPrintLog } = this.props;
    dispatchAddPrintLog && dispatchAddPrintLog(`#${checkNumber} | ${printerName || '--'} | ${printerIpAddress || '--'} | ${status}`);
    EventEmitter.addLogs(
      'appLogs',
      LogLevelEnum.INFO,
      `Print - ${moment(new Date).format('YYYY-MM-DD hh:mm:ss')} | Check Id - ${checkId} | Check Number - ${checkNumber} | Print Type - ${printType} | Printer Name - ${printerName} | Printer IP Address - ${printerIpAddress} | Print Status - ${status}`
    );
  };

  showCalendar = () => {
    this.setState({
      popup: {
        type: "calendar",
      },
    });
  };

  invokeGratuityApi = (gratuity) => {
    const { preAuthItem } = this.state;
    const { reduxProps, navigation } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { latitude, longitude } = UTILLib.location;
    const unpaid = preAuthItem.unpaidAmount;
    const preauthTicket =
      preAuthItem.tickets &&
      preAuthItem.tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaid > 0);
    const gratuityCalculated = ((unpaid * +gratuity) / 100).toFixed(2);

    this.getSpinner('spinner', 'Posting payment', null);

    API.preAuthCompleteFB({
      latitude,
      longitude,
      geoLocation: `${latitude} ${longitude}`,
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      employeeId: login && login.data && login.data.id,
      checkHeaderId: preAuthItem.id,
      ticketId: preauthTicket ? preauthTicket.id : null,
      totalAmount: unpaid,
      tipAmount: +gratuityCalculated,
      paymentAmount: unpaid + +gratuityCalculated,
    })
      .then(res => {
        console.info('response from preAuthCompleteFB', res);
        this.dismissPopup();
        FireboardUtils.addNetworkLogs(res);
      })
      .catch(error => {
        console.info('error', error.request, error.response);
        this.handleErrorPopup(error);
      });
  };


  tipSubmit = (gratuity) => {
    const popup = getPopupConfig('error');
    popup.heading = constants.CustomTipConfirm;
    popup.message = constants.gratuityPostMessage;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.setState({ popup: { type: "fbPreAuth" } }),
      },
      {
        text: constants.yes,
        onClick: () => {
          this.invokeGratuityApi(gratuity);
        },
      },
    ];
    console.info('tipSubmit popup...', popup);
    this.setState({ popup });
  }

  onPreAuth = (item) => {
    const { history, reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { defaultPreAuthTipPercentage, supportsGratuityForPreAuth } = storeInfo?.data || {};
    history.push({
      pathname: '/fireboardPreAuth',
      state: {
        item: JSON.stringify(item),
        defaultPreAuthTipPercentage: defaultPreAuthTipPercentage,
        supportsGratuityForPreAuth: supportsGratuityForPreAuth,
        deviceTypeId: 13,
      }
    });
  };

  onResyncCheck = item => {
    this.getPopup('spinner', constants.syncingCheck, null);
    API.syncCheck({
      checkHeaderId: item.checkHeaderId,
    })
      .then(response => {
        const checkData = FBCommonUtil.parseCheckFromRedis(response.data);
        this.checks.set(response.data.id, checkData);
        this.toggleSelection(true);
        const { selectedItem } = this.state;
        this.setState({ popup: undefined, selectedItem: { ...checkData, rowIndex: selectedItem.rowIndex } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        this.handleErrorPopup(error);
      });
  };

  onDateChange = (date) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { prepTime } = this.state;
    this.setState(
      (prevState) => ({
        selectedDate: date,
        orderStatusType: prevState.orderStatusType,
        orderType: prevState.orderType,
      }),
      () => {
        if (date) {
          this.getPopup("spinner", constants.getFutureOrders, null);
          const { latitude, longitude } = UTILLib.location;
          const convertedDate = FireboardUtils.convertedDate(date);
          API.getFutureOrders({
            latitude,
            longitude,
            storeId: storeInfo.data.id,
            businessDate: convertedDate,
          })
            .then((res) => {
              const filteredChecklist = res.data.slice().map((check) => {
                let updatedCheck = {
                  ...FBCommonUtil.parseCheckFromRedis(check),
                  isNew: check.isNew || false,
                };
                const dueTime = FBCommonUtil.getDueTime(updatedCheck);
                updatedCheck = {
                  ...updatedCheck,
                  elapsedTime: FireboardUtils.getElapsedTime(updatedCheck, prepTime),
                  dueTime: new Date(dueTime).getTime(),
                  dueTimeDisplay: dueTime,
                };
                return updatedCheck;
              });
              this.futureCheckItems = filteredChecklist;
              this.setState({
                popup: undefined,
                filteredChecklist,
                selectedItem: {},
                items: [],
              });
              FireboardUtils.addNetworkLogs(res);
            })
            .catch((error) => {
              console.debug(
                "error from getFutureOrders api",
                error,
                error.response
              );
              this.futureCheckItems = [];
              this.setState({ filteredChecklist: [] });
              this.handleErrorPopup(error);
            });
        } else {
          this.toggleSelection();
        }
      }
    );
  };

  snoozeInterval = () => {
    clearInterval(this.snoozeTimeInterval);
    this.snoozeTimeInterval = setInterval(() => {
      this.setState({ snoozeEnabled: false });
    }, 1 * TimeConstants.MINUTE);
    this.setState({ snoozeEnabled: true });
  };

  getNewCheckCount = (sourceType) => {
    let count = 0;
    Array.from(this.checks.values()).forEach((check) => {
      if (!check || !check.isNew) {
        return;
      }
      if (check.sourceType === sourceType) {
        count++;
      }
    });
    return count;
  };

  getPendingCount = (sourceType) => {
    let count = 0;
    Array.from(this.checks.values()).forEach((check) => {
      if (
        check.sourceType === sourceType &&
        (check.orderStatusId === 1 || check.orderStatusId === 0)
      ) {
        count++;
      }
    });
    return count;
  };

  getSubTypes = (type) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    let subTypes = [];
    if (type === "orderType") {
      subTypes = [allOrderType].concat(storeInfo.data.orderTypes.slice());
    } else {
      subTypes = [allOrderType].concat(storeInfo.data.revenueCenters.slice());
    }
    if (subTypes && subTypes.length > 0) {
      return subTypes.map((each) => each.name);
    }
    return [];
  };

  getOrderTypes = () => {
    const { reduxProps } = this.props;
    const { storeTypesPersist } = reduxProps;
    if (storeTypesPersist.data.activeCheckFilter === "sourceType") {
      return storeTypesPersist.data.sourceTypes.length === 0
        ? data.orderTypes
        : storeTypesPersist.data.sourceTypes;
    }
    if (storeTypesPersist.data.activeCheckFilter === "orderType") {
      return storeTypesPersist.data.orderTypes.length === 0
        ? this.getSubTypes("orderType")
        : storeTypesPersist.data.orderTypes;
    }
    return storeTypesPersist.data.revenueTypes.length === 0
      ? this.getSubTypes("revenueCenter")
      : storeTypesPersist.data.revenueTypes;
  };

  getManagerNotifications = () => {
    const { reduxProps } = this.props;
    const { managerMode } = this.state;
    const { notifications } = reduxProps;
    if (managerMode) {
      // return notifications.filter(n => n.notificationTypeId === 14 || n.notificationTypeId === 15);
      return notifications.filter(n => n.notificationTypeId === 14);
    }
    return [];
  };

  onLogout = () => {
    this.setState({ managerMode: false, selectedItem: {}, items: [] });
    const { history } = this.props;
    if (history && history.location && history.location.state && history.location.state.managerMode) {
      const state = { ...history.location.state };
      state.managerMode = false;
      history.replace({ ...history.location, state });
    }
  }

  // showApprovalReasonsPopup = (approval, notification) => {
  //   const { reduxProps } = this.props;
  //   const { storeInfo } = reduxProps;
  //   const { overServeApproveReasons, overServeRejectReasons } = storeInfo.data;
  //   if (approval) {
  //     if (overServeApproveReasons && overServeApproveReasons.length > 0) {
  //       const popup = {};
  //       popup.type = 'overServerReasons';
  //       this.setState({
  //         popup,
  //         reasonsList: overServeApproveReasons,
  //         reasonType: 'approval',
  //         overServerNotification: notification,
  //       });
  //     } else {
  //       this.acknowledgeOverServe(true, notification);
  //     }
  //   } else if (overServeRejectReasons && overServeRejectReasons.length > 0) {
  //     const popup = {};
  //     popup.type = 'overServerReasons';
  //     this.setState({
  //       popup,
  //       reasonsList: overServeRejectReasons,
  //       reasonType: 'reject',
  //       overServerNotification: notification,
  //     });
  //   } else {
  //     this.acknowledgeOverServe(false, notification);
  //   }
  // };

  mgrFilterClickHandler = fltr => {
    this.setState({ activeMgrFilter: fltr.key });
  }
  resetSelectedReason = () => {
    this.setState({ selectedReason: {} });
  };

  // submitReason = () => {
  //   const { selectedReason, reasonType, overServerNotification } = this.state || {};
  //   if (reasonType === 'approval') {
  //     this.acknowledgeOverServe(true, overServerNotification, selectedReason);
  //   } else if (reasonType === 'reject') {
  //     this.acknowledgeOverServe(false, overServerNotification, selectedReason);
  //   }
  // };

  onPressReason = reason => {
    if (reason) {
      this.setState({ selectedReason: reason });
    }
  };

  onLoginPress = id => {
    const { managerMode } = this.state;
    if (!managerMode) {
      const { reduxProps: { deviceApi }, dispatchLogin } = this.props;
      const { deviceId } = deviceApi?.data;
      dispatchLogin(deviceId, id || null, null, true);
    }
  };

  onOutOfStockItemsPress = (type, update) => {
    const { outOfStockSearchList } = this.state;
    this.getOutOfStockList(type);
    this.setState({ outOfStockMode: type, popup: { type }, outOfStockSearchList: update ? [] : outOfStockSearchList });
  };

  getOutOfStockList = type => {
    this.getPopup('spinner', 'Getting out of stock list');
    let req = 'getOutOfStockItemList';
    if (type === 'modifiers') req = 'getOutOfStockModifierList';
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;

    API[req]({
      storeId: id,
    }).then(res => {
      this.setState(
        {
          outOfStockItems: res.data,
          isClickedOutOfStock: true,
          outOfStockMode: type,
          popup: { type }
        },
      );
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => {
      this.handleErrorPopup(error);
    })
  };

  searchOutOfStockItems = (type, value) => {
    this.getPopup('spinner', 'Searching items');
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;
    let req = 'searchItemStock';
    if (type === 'modifiers') req = 'searchModifierStock';
    API[req]({
      storeId: id,
      postId: null,
      name: value,
    }).then(res => {
      this.setState({
        outOfStockSearchList: res.data,
        isClickedOutOfStock: false,
        popup: { type },
      });
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => {
      console.info('error', error.request, error.response);
      this.handleErrorPopup(error);
    })
  };

  updateItemStock = (item, type) => {
    const oldPopup = this.state.popup;
    const popup = getPopupConfig('error');
    popup.heading = 'Update the item stock ?';
    popup.message = 'This will update the items stock status';
    popup.buttons = [
      {
        text: 'Cancel',
        onClick: () => {
          this.setState({
            popup: oldPopup,
          });
        },
      },
      {
        text: 'Proceed',
        onClick: () => {
          this.getPopup('spinner', 'Updating item stock');
          let request = 'updateItemStock';
          if (type === 'modifiers') request = 'updateModifierStock';
          const { reduxProps } = this.props;
          const { storeInfo } = reduxProps;
          const { id } = storeInfo.data;
          API[request]({
            storeId: id,
            id: item.id,
            stocked: !item.stocked,
          }).then(res => {
            console.info('res', res.data);
            this.updateItem({ ...res.data }, type);
            FireboardUtils.addNetworkLogs(res);
          }).catch(error => {
            console.info('error', error.request, error.response);
            this.handleErrorPopup(error);
          })
        },
      }
    ];
    this.setState({ popup });
  }

  updateItem = (updatedItem, type) => {
    const { outOfStockItems, isClickedOutOfStock, outOfStockSearchList } = this.state;
    const copiedItems = outOfStockItems.slice();
    const itemIndex = copiedItems.findIndex(mi => mi.id === updatedItem.id);
    if (itemIndex > -1) {
      if (isClickedOutOfStock) {
        copiedItems.splice(itemIndex, 1);
      } else {
        copiedItems.splice(itemIndex, 1, updatedItem);
      }
    }
    this.setState({
      outOfStockItems: copiedItems,
      outOfStockSearchList: outOfStockSearchList.map(i => {
        if (i.id === updatedItem.id) {
          return {
            ...i,
            stocked: !i.stocked,
          }
        }
        return { ...i };
      })
    }, () => this.onOutOfStockItemsPress(type, false));
  };

  doPairWatch = value => {
    const { reduxProps: { deviceApi }, dispatchLogin } = this.props;
    const { deviceId } = deviceApi?.data;
    const { loginInfo } = this.state;
    if (loginInfo) {
      this.pairWatch(value);
      return;
    }
    const popup = getPopupConfig('spinner');
    this.setState({ popup });
    this.allowPairWatch = true;
    dispatchLogin(deviceId, value || null, null, false);
  };

  pairWatch = code => {
    const { loginInfo } = this.state;
    const { reduxProps: { storeInfo } } = this.props;
    const spinner = getPopupConfig('spinner');
    this.setState({ popup: spinner });
    API.pairWatch({
      employeeId: loginInfo && loginInfo.id,
      storeId: storeInfo.data.id,
      uuid: '',
      activationCode: code,
    }).then(res => {
      console.info('res', res);
      this.setState({ popup: undefined });
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => {
      console.info('error', error.response);
      this.handleErrorPopup(error);
    });
  };

  get viewProps() {
    const {
      snoozeEnabled,
      selectedItem = {},
      items = [],
      popup,
      isDevEnvironment,
      showNotifications,
      value,
      showSearchBox,
      orderStatusType,
      selectedDate,
      futureOrdersList,
      productionTime,
      prepTime,
      countStatus,
      notificationControlEnabled,
      fromFooter,
      preAuthItem,
      managerMode,
      pendingCheckItems,
      activeMgrFilter,
      counters,
      orderType,
      selectedReason,
      reasonsList,
      sensorData,
      sortFilter,
      outOfStockItems,
      outOfStockMode,
      outOfStockSearchList,
      loginInfo,
      printLogs,
    } = this.state || {};
    const {
      reduxProps: { storeInfo, currencyInfo, fbNetworkLogs, deviceApi, deviceApiData },
      history,
    } = this.props || {};
    const { deviceName } = deviceApi?.data || deviceApiData || {};
    const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } = storeInfo && storeInfo.data ? storeInfo.data.serverAppFeatures : {};
    const { onlineOrderAdvanceLimit = 1, defaultPreAuthTipPercentage, supportsGratuityForPreAuth, supportPhoneNumber } = storeInfo?.data || {};
    const notificationsToBeDisplayed = this.getNotificationsToBeDisplayed();
    const newNotificationCount = Array.isArray(notificationsToBeDisplayed)
      ? notificationsToBeDisplayed.filter(n => n.isNew).length
      : 0;
    const { rnDevEnv, iso2 } = currencyInfo || {};
    const { networkLogs } = fbNetworkLogs || {};
    return {
      currency: this.currency,
      rnDevEnv,
      iso2,
      popup,
      isDevEnvironment,
      baseUrl: window.location.origin || '',
      setSelectedCheck: this.setSelectedCheck,
      selectedItem,
      checksRowData: this.checksRowData,
      notificationsData: this.notificationsData,
      onUpdate: this.onUpdate,
      items,
      supportsTipsOnTotalAmount,
      suppressTipsOnFireBoard,
      showMemberDetailPopup: this.showMemberDetailPopup,
      onPrintPress: this.onPrintPress,
      setNotifications: this.setNotifications,
      showNotifications: showNotifications,
      onOpenSearchBox: this.onOpenSearchBox,
      onSearchReset: this.onSearchReset,
      value: value,
      showSearchBox: showSearchBox,

      resetFilterCalendar: this.resetFilterCalendar,

      handleChange: this.handleChange,
      searchChecks: this.searchChecks,
      removeNewTag: this.removeNewTag,
      isFutureOrderType: orderStatusType === constants.futureOrder,
      showCalendar: this.showCalendar,
      onDateChange: this.onDateChange,
      selectedDate: selectedDate,
      onlineOrderAdvanceLimit,
      futureOrdersList: futureOrdersList,
      storeInfo: storeInfo.data,
      markItemAPaid: this.markItemAPaid,
      onHandleTextToPay: this.onHandleTextToPay,
      updateOrderStatus: this.updateOrderStatus,
      joinCheck: this.joinCheck,
      onPrint: this.printCheck,
      onHandleSms: this.onHandleSms,
      onQRGenerate: this.generateQR,
      textToCheckIn: this.textToCheckIn,
      onHandleSend: this.onHandleSend,
      onClose: this.closePopup,
      notificationControlEnabled: notificationControlEnabled,
      fromFooter,
      goToCheck: this.goToCheck,
      pendingItems: pendingCheckItems,
      acknowledgeIdCheck: this.acknowledgeIdCheck,
      // showApprovalReasonsPopup: this.showApprovalReasonsPopup,
      selectedReason: selectedReason,
      reasonsList: reasonsList,
      resetSelectedReason: this.resetSelectedReason,
      // submitReason: this.submitReason,
      onPressReason: this.onPressReason,

      managerFilters: filterInfo,
      onMgrFilterClick: this.mgrFilterClickHandler,
      activeMgrFilter,

      // FOOTER PROPS
      supportNumber: FireboardUtils.formattedPhoneNumber(supportPhoneNumber, iso2),
      isDev: true,
      buildVersion: version,
      invokeScanToPay: this.invokeScanToPay,
      invokeCheckIn: this.invokeCheckIn,
      invokeTextToPay: this.invokeTextToPay,
      onFooterIconPress: this.onFooterIconPress,
      setNotificationType: this.setNotificationType,
      setCounterType: this.setCounterType,
      setSortType: this.setSortType,
      sortFilter,

      // HEADER PROPS
      onChange: this.headerPress,
      onSaveFilter: this.onSaveFilter,
      counters,
      orderType,
      onToggleCount: this.onToggleCount,
      curbCount: this.getNewCheckCount(SourceTypes.CurbSide),
      onlineCount: this.getNewCheckCount(SourceTypes.Online),
      walkupCount: this.getNewCheckCount(SourceTypes.WalkUp),
      textToPayCount: this.getNewCheckCount(SourceTypes.TextToPay),
      curbPendingCount: this.getPendingCount(SourceTypes.CurbSide),
      onlinePendingCount: this.getPendingCount(SourceTypes.Online),
      walkupPendingCount: this.getPendingCount(SourceTypes.WalkUp),
      textToPayPendingCount: this.getPendingCount(SourceTypes.TextToPay),
      prepTime: prepTime,
      production: productionTime,
      countStatus: countStatus,
      totalNotificationsCount:
        Array.isArray(notificationsToBeDisplayed)
          ? notificationsToBeDisplayed.filter(n => n).length
          : 0,
      notificationCount: newNotificationCount,
      snoozeNotifications: this.snoozeInterval,
      snoozeEnabled,
      orderTypes: this.getOrderTypes(),
      reSync: this.reSync,
      onResyncCheck: this.onResyncCheck,
      onPreAuth: this.onPreAuth,
      preAuthItem: preAuthItem,
      tipSubmit: this.tipSubmit,
      managerMode: managerMode,
      onLogout: this.onLogout,
      getManagerNotifications: this.getManagerNotifications(),
      dismissPopup: this.dismissPopup,
      sensorData,
      onLoginPress: this.onLoginPress,
      defaultPreAuthTipPercentage,
      supportsGratuityForPreAuth,
      networkLogs,
      outOfStockItems,
      outOfStockMode,
      outOfStockSearchList,
      onOutOfStockItemsPress: this.onOutOfStockItemsPress,
      searchOutOfStockItems: this.searchOutOfStockItems,
      getOutOfStock: this.getOutOfStockList,
      updateItemStock: this.updateItemStock,
      loginInfo,
      doPairWatch: this.doPairWatch,
      history,
      printLogs,
      deviceName,
    };
  }

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateNotification: (payload) => {
    dispatch(updateNotification(payload));
  },
  dispatchUpdateStatusType: (payload) => {
    dispatch(updateStatusType(payload));
  },
  dispatchUpdateNotificationType: (payload) => {
    dispatch(updateNotificationType(payload));
  },
  dispatchAcknowledgeNotification: (payload) => {
    dispatch(acknowledgeNoticationAction(payload));
  },
  dispatchPrintAction: (payload) => {
    dispatch(tableReceipt(payload));
  },
  dispatchUpdateCheckSort: (payload) => {
    dispatch(updateCheckSort(payload));
  },
  dispatchLogin: (storeId, code, employeeCard, managerMode) => {
    dispatch(loginAction(storeId, version, code, employeeCard, null, managerMode));
  },
  dispatchUpdateCompState: (payload) => {
    dispatch(updateComponentState(payload));
  },
  dispatchAddPrintLog: payload => {
    dispatch(addPrintLog(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withSocketContext(Fireboard));
